<template>

    <div>

        <!-- BEGIN Background blocker -->
        <div class="absolute bg-theme-dropdowndismissal w-full h-full opacity-75 overflow-hidden" style="top: 0; left: 0;"></div>
        <!-- END Background blocker -->

        <!-- BEGIN The Container -->
        <div class="relative flex flex-row items-center justify-center h-8">

            <input id="searchbar" name="searchbar" type="text"
                   v-model="query"
                   @blur="searchResultsVisible = false"
                   @focus="searchResultsVisible = true"
                   @keydown.esc="searchResultsVisible = false"
                   @input="softReset"
                   ref="search"
                   @keyup="performSearch"
                   @keydown.up.prevent="highlightPrevious"
                   @keydown.down.prevent="highlightNext"
                   @keydown.enter="gotoLink"
                   class="bg-theme-level5 appearance-none w-4/5 px-3 text-theme-copy3 h-full leading-tight focus:outline-none rounded-full mt-8"
                   :placeholder="translate('searchbar-placeholder')"
                   autocomplete="off"
            />

            <i class="material-icons text-theme-control-label ml-2 pt-8 outline-none" style="font-size: 32px;" @click="dismissSearch">cancel</i>

            <div v-if="query.length > 0"
                 class="absolute top-0 right-0 text-2xl mr-3 cursor-pointer text-theme-muted hover:text-theme-main"
                 style="top: 19px; right: 15%;"
                 @click="reset"
            >
                &times;
            </div>

            <div v-if="query.length > 0 && searchResultsVisible"
                 class="absolute bg-theme-level4 rounded-lg shadow-2xl mt-1 inline-block
                        w-full transform -translate-x-1/2 z-10
                        flex flex-col text-left disable-scrollbars"
                 :class="{'overflow-y-scroll': searchResults.length > 0}"
                 style="left: 50%; max-height: 38rem; top: 70px;"
                 ref="resultsPanel">

                <a v-for="(searchableSource, index) in searchResults" :key="index"
                   :href="'/view/' + searchableSource.item.id"
                   @mousedown.prevent.stop="gotoLinkWithIndex(index)"
                   @click.prevent.stop="gotoLinkWithIndex(index)"
                   :class="{'bg-theme-level2': index === highlightedIndex}"
                   class="border-b border-theme-level2 text-lg px-8 pt-8 pb-6 cursor-pointer hover:bg-theme-level2 text-theme-title hover:text-theme-main mb-4"
                >
                    {{ searchableSource.item.title }}

                    <span class="block font-normal text-sm my-2 text-theme-discrete mb-4 leading-normal flex flew-row flex-wrap">
                            <span><strong v-text="translate('searchbar-category')"></strong> { searchableSource.item.categories.substring(0, 30) }}...</span>
                            <span><strong v-text="translate('searchbar-tag')"></strong> {{ searchableSource.item.tags.substring(0, 30) }}...</span>
                        </span>
                </a>

                <div v-if="searchResults.length === 0" class="font-normal w-full border-b px-6 py-4" style="height: 100vh;">
                    <p class="my-0 text-theme-discrete">{{ translate('searchbar-not-found') }} <span class="text-theme-main">'<strong>{{ query }}</strong>'</span></p>
                </div>

            </div>

        </div>
        <!-- END The Container -->

    </div>

</template>

<script>

    const Lang = require('lang.js');
    import translations from './messages.js';

    const lang = new Lang();

    lang.setMessages(translations);

    export default {

        data() {
            return {
                query: '',
                searchIsVisible: false,
                searchResultsVisible: false,
                searchableSource: [],
                searchResults: [],
                highlightedIndex: 0,
                options: {
                    shouldSort: true,
                    includeMatches: true,
                    threshold: 0.5,
                    location: 0,
                    distance: 500,
                    maxPatternLength: 32,
                    minMatchCharLength: 1,
                    keys: ['title', 'categories', 'tags']
                }
            }
        },

        props: [
            'currentlocale'
        ],

        methods: {

            translate(key) {
                key = 'strings.' + key;
                return lang.get(key);
            },

            dismissSearch() {
                Event.fire('hideMobileSearch');
            },

            reset() {
                this.query = '';
                this.highlightedIndex = 0;
            },

            softReset() {
                this.searchResultsVisible = true;
                this.highlightedIndex = 0;
            },

            performSearch() {

                this.$search(this.query, this.searchableSource, this.options)
                    .then(results => {
                        this.searchResults = results
                    })

            },

            highlightPrevious() {
                if(this.highlightedIndex > 0) {
                    this.highlightedIndex--;
                } else {
                    this.highlightedIndex = this.searchResults.length - 1;
                }

                this.scrollIntoView();

            },

            highlightNext() {
                if(this.highlightedIndex < this.searchResults.length - 1) {
                    this.highlightedIndex++;
                } else {
                    this.highlightedIndex = 0;
                }

                this.scrollIntoView();
            },

            scrollIntoView() {
                this.$refs.resultsPanel.children[this.highlightedIndex].scrollIntoView({ block: 'nearest'});
            },

            gotoLink() {
                if(this.searchResults[this.highlightedIndex]) {

                    /*let contentPiece = '';*/
                    /*let catsArray = [];*/

                    Event.fire('hideMobileSearch');

                    axios.get('/api/content/' + this.searchResults[this.highlightedIndex].item.id)
                        .then(response => {
                            console.log('Showing content from Search bar...');
                            this.searchResultsVisible = false;
                            Event.fire('showPlayer', { language: this.currentlocale, data: response.data });
                        })
                        .catch(error => {
                            console.log('Error from Seacrh Bar: ' + JSON.stringify(error));
                        });

                    /*axios.get('/api/content/data?contentId=' + this.searchResults[this.highlightedIndex].item.id)
                        .then(response => {
                            catsArray = response.data
                        });*/

                    /*this.$root.shared.playerPayload = contentPiece;
                    this.$root.shared.playerCategories = catsArray;*/



                    /*window.location = '/view/' +  this.searchResults[this.highlightedIndex].item.id*/
                }
            },

            gotoLinkWithIndex(index) {

                if(this.searchResults[index]) {

                    /*let contentPiece = '';*/
                    /*let catsArray = [];*/

                    Event.fire('hideMobileSearch');

                    axios.get('/api/content/' + this.searchResults[index].item.id)
                        .then(response => {
                            console.log('Showing content from Search bar...');
                            this.searchResultsVisible = false;
                            Event.fire('showPlayer', { language: this.currentlocale, data: response.data });
                            /*contentPiece = response.data*/
                        })
                        .catch(error => {
                            console.log('Error from Seacrh Bar: ' + JSON.stringify(error));
                        });

                    /*axios.get('/api/content/data?contentId=' + this.searchResults[this.highlightedIndex].item.id)
                        .then(response => {
                            catsArray = response.data
                        });*/

                    /*this.$root.shared.playerPayload = contentPiece;
                    this.$root.shared.playerCategories = catsArray;*/



                    /*window.location = '/view/' +  this.searchResults[this.highlightedIndex].item.id*/
                }
            }
        },

        created() {

            if(this.currentlocale==='es') {
                axios.get('/api/searchindex')
                    .then(response => {
                        this.searchableSource = response.data
                    });
            } else {
                axios.get('/api/searchenindex')
                    .then(response => {
                        this.searchableSource = response.data
                    });
            }

        },

        mounted() {
            console.log('SearchBar component mounted.')
        }
    }
</script>
